module.exports = __webpack_public_path__ + "static/media/weight.423ff3ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/weight.svg
// module id = 1462
// module chunks = 0